module.exports = __webpack_public_path__ + "img/[西瓜].6a3f4db4.svg";